import { isUserBelongsToCompany } from '@/redux/user/sagas/signInSaga'
import { put, select } from 'redux-saga/effects'
import { fetchCategoriesByCompanyAction, fetchCompanyDetailsAction } from '../../handles'
import { resetCampaignDataAction } from '../../handles/resetCampaignDataAction'
import { setSelectedCompanyAction } from '../../handles/setSelectedCompanyAction'
import { fetchCampaignById } from '../_http/company'

export function* setSelectedCompanySaga(action: ReturnType<typeof setSelectedCompanyAction.request>) {
  const { selectedCompany, user, navigate } = action.payload
  try {
    const userBelongsToCompany = yield isUserBelongsToCompany(selectedCompany, user as any)
    if (!userBelongsToCompany) throw new Error('Usuário não atende para essa empresa.')
    const response = yield fetchCampaignById({ campaignId: selectedCompany })
    const company = response?.campaign ?? response
    const selectedCompanyOwnerId = company?.ownerId ?? null
    if (selectedCompanyOwnerId) localStorage.setItem('devchat_app_selectedCompanyOwnerId', selectedCompanyOwnerId)
    const currentCompany: string | null = yield select((state: any) => state.companyReducer.selectedCompany)
    if (currentCompany !== selectedCompany) {
      yield put(resetCampaignDataAction())
      localStorage.removeItem('devchat_app_selectedDepartment')
    }
    yield put(setSelectedCompanyAction.success({ selectedCompany, selectedCompanyOwnerId }))
    yield put(fetchCompanyDetailsAction.success({ company }))
    yield put(fetchCategoriesByCompanyAction.request({ companyId: selectedCompany }))
  } catch (error) {
    yield put(setSelectedCompanyAction.failure(error))
    localStorage.removeItem('devchat_app_selectedCompanyId')
    localStorage.removeItem('devchat_app_selectedCompanyOwnerId')
    localStorage.removeItem('devchat_app_selectedDepartment')
    yield navigate('/select-campaign')
  }
}
